























































































import {
 Component,
 Vue,
 Watch,
} from 'vue-property-decorator';
import axios from 'axios';
import { getModule } from 'vuex-module-decorators';
import SerasaFile from '@/views/clients/components/SerasaFile.vue';
import ClientModule from '@/stores/modules/ClientModule';
import AuthenticationModule from '@/stores/modules/AuthenticationModule';
import NavigationTabs from '@/components/navigation/tabs/NavigationTabs.vue';
import InputRulesHelper from '@/helpers/InputRulesHelper';
import ClientRepository from '@/repositories/ClientRepository';
import NavigationTabsType from '@/types/NavigationTabsType';
import CurrencyHelper from '@/helpers/CurrencyHelper';
import StatusChip from '@/components/tables/StatusChip.vue';
import StatusEnum from '@/domain/enums/StatusEnum';
import { saveChanges } from './services/CustomerChangeService';

@Component({
  components: {
    NavigationTabs,
    SerasaFile,
    StatusChip,
  },
})
export default class Client extends Vue {
  public selectedTab: number = 0;

  public tabs: NavigationTabsType[] = [
    {
      name: 'Ficha financeira',
      path: `${this.baseSpecificCustomerPath}/`,
    },
    {
      name: 'Informações gerais',
      path: `${this.baseSpecificCustomerPath}/informacoes-gerais`,
    },
    {
      name: 'Contatos',
      path: `${this.baseSpecificCustomerPath}/contatos`,
    },
    {
      name: 'Inf. Complementares',
      path: `${this.baseSpecificCustomerPath}/informacoes-complementares`,
    },
    {
      name: 'Vendas',
      path: `${this.baseSpecificCustomerPath}/vendas`,
    },
    {
      name: 'Histórico de Cobrança',
      path: `${this.baseSpecificCustomerPath}/historico-de-cobranca`,
    },
  ];
  public readonly rulesHelper: InputRulesHelper = new InputRulesHelper();
  public readonly clientModule: ClientModule = getModule(ClientModule);
  public readonly authenticationModule: AuthenticationModule = getModule(AuthenticationModule);
  public readonly clientRepository: ClientRepository = new ClientRepository();

  public additionalPageTitleInformation: string = '';

  get companyIds(): number[] {
    return this.authenticationModule.companyIds;
  }

  get companyGroupId(): number {
    return Number(this.authenticationModule.user.company_group_id);
  }

  public get idCustomer(): string {
    return this.$route.params.idCustomer;
  }

  public get companyId(): string {
    return this.$route.params.companyId;
  }

  public get showSerasaConsultationActions(): boolean {
    if (this.$route.name === null || this.$route.name === undefined) {
      return false;
    }

    return ['ClientGeneral', 'ClientInformation'].includes(this.$route.name);
  }

  public get baseSpecificCustomerPath(): string {
    return `/clientes/${this.idCustomer}`;
  }

  public status = [
    {
      value: StatusEnum.ACTIVE,
      label: 'Ativo',
      color: 'success',
    },
    {
      value: StatusEnum.INACTIVE,
      label: 'Inativo',
      color: 'error',
    },
  ];

  @Watch('$route')
  public onChangeRoute() {
    this.selectedTab = this.defineTabByRoute(this.$route.name);
  }

  public async created(): Promise<void> {
    this.selectedTab = this.defineTabByRoute(this.$route.name);
    this.loadInitialInformation();
  }

  public defineTabByRoute(routeName: string | null | undefined): number {
    switch (routeName) {
      case 'ClientFinancialStatement':
        return 0;
      case 'ClientGeneral':
        return 1;
      case 'ClientContacts':
        return 2;
      case 'ClientInformation':
        return 3;
      case 'ClientSells':
        return 4;
      case 'ClientHistory':
        return 5;
      default:
        return 0;
    }
  }

  public async loadInitialInformation(): Promise<void> {
    this.$dialog.startLoading();

    await Promise.all([this.getClientById()]);

    this.$dialog.stopLoading();

    this.generateTitleAdditionalInformation();
  }

  public async getClientById(): Promise<void> {
    try {
      this.clientModule.setClientLoading(true);
      const client = await this.clientRepository
        .getClientById(this.idCustomer, this.companyGroupId, this.companyIds);

      client.limit = CurrencyHelper
        .toCurrency(client.limit, { showCurrencySymbol: false });
      client.balanceDue = CurrencyHelper
        .toCurrency(client.balanceDue, { showCurrencySymbol: false });

      this.clientModule.setClient(client);
    } catch (error) {
      this.$notification.error('Houve um problema ao requisitar o cliente selecionado!');
    } finally {
      this.clientModule.setClientLoading(false);
    }
  }

  public generateTitleAdditionalInformation() {
    this.additionalPageTitleInformation = `${this.clientModule.client.companyName} - ${this.clientModule.client.cnpj}`;
  }

  public async handleSaveChanges(): Promise<void> {
    try {
      this.$dialog.startLoading();
      this.clientModule.setClientLoading(true);

      await saveChanges(
        this.idCustomer,
        this.companyGroupId,
        this.clientModule.client,
      );
    } catch (error) {
      let errorMessage = 'Houve um problema ao salvar as alterações do cliente!';

      if (axios.isAxiosError(error)) {
        errorMessage = this.$helpers.extractAxiosErrorMessage(error, errorMessage);
      }

      if (error instanceof Error && error.name === 'CustomerParametersValidationException') {
        errorMessage = error.message;
      }

      this.$notification.error(errorMessage);
    } finally {
      this.$dialog.stopLoading();
      this.clientModule.setClientLoading(false);
    }
  }
}
